// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.users__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.users__title {
  color: #ffffff;
  margin-bottom: 12px;
  font-size: 18px;
}
.users__pagination {
  margin-top: 16px;
}

.users-table {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}
.users-table__header, .users-table__row {
  display: grid;
  column-gap: 8px;
  padding: 15px 26px;
  align-items: center;
  border-radius: 20px;
  margin-bottom: 10px;
}
.users-table__header {
  background: rgba(35, 38, 43, 0.95);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.3px;
  color: #a9adb3;
  grid-template-columns: 0.6fr 2fr 2fr 1.4fr 1.2fr;
}
.users-table__body {
  display: flex;
  flex-direction: column;
}
.users-table__row {
  font-size: 14px;
  color: #f4f4f4;
  border: 1px solid rgba(70, 74, 81, 0.7);
  background: rgba(35, 38, 43, 0.95);
  border-radius: 20px;
  grid-template-columns: 0.6fr 2fr 2fr 1.4fr 1.2fr;
}
.users-table__cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.users-table__cell--id {
  font-weight: 500;
}
.users-table__cell--actions {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}
.users-table__accordion {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
  opacity: 0;
  padding: 0 16px;
  background: rgba(18, 19, 22, 0.9);
}
.users-table__accordion-inner {
  padding-top: 12px;
  padding-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.users-table__accordion-rows {
  display: flex;
  align-items: flex-end;
  gap: 25px;
}
.users-table__accordion--open {
  max-height: 600px;
  opacity: 1;
  padding: 0 16px 12px;
}
.users-table__form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}
.users-table__form-row {
  min-width: 220px;
  max-width: 320px;
  flex: 1 1 220px;
}
.users-table__form-actions {
  display: flex;
  gap: 8px;
}
.users-table__roles {
  display: flex;
  gap: 12px;
  align-items: center;
}
.users-table__roles-row {
  display: flex;
  gap: 12px;
  align-items: center;
}
.users-table__roles-row > * {
  flex-shrink: 0;
}
.users-table__tokens {
  margin-top: 8px;
}
.users-table__tokens-title {
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 8px;
}
.users-table__tokens-table {
  border-radius: 12px;
  border: 1px solid rgba(70, 74, 81, 0.7);
  background: rgba(24, 26, 30, 0.9);
  overflow: hidden;
}
.users-table__tokens-header, .users-table__tokens-row {
  display: grid;
  grid-template-columns: 0.6fr 1.1fr 1.1fr 3.2fr 1.2fr 1.2fr;
  column-gap: 8px;
  padding: 10px 14px;
  align-items: center;
}
.users-table__tokens-header {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #a9adb3;
  background: rgba(35, 38, 43, 0.95);
}
.users-table__tokens-body {
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-height: 300px;
}
.users-table__tokens-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.users-table__tokens-cell--id {
  font-weight: 500;
}
.users-table__tokens-cell--token {
  white-space: normal;
  word-break: break-all;
  font-size: 11px;
  line-height: 1.3;
  max-height: 3.6em;
}
.users-table__tokens-cell--actions {
  display: flex;
  justify-content: flex-end;
}
.users-table__tokens-empty {
  padding: 10px 14px;
  font-size: 13px;
  color: #a9adb3;
}
.users-table__empty {
  padding: 16px;
  text-align: center;
  color: #a9adb3;
}
@media (max-width: 1024px) {
  .users-table__header {
    display: none;
  }
  .users-table__row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 4px;
    column-gap: 8px;
    padding: 12px 16px;
  }
  .users-table__cell {
    white-space: normal;
  }
  .users-table__cell--actions {
    grid-column: 1/-1;
    justify-content: flex-start;
    margin-top: 6px;
  }
  .users-table__tokens-header, .users-table__tokens-row {
    grid-template-columns: 0.6fr 2.2fr 1.2fr 1.4fr 1.4fr 1.2fr;
    padding: 8px 10px;
  }
  .users-table__roles-row {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (max-width: 600px) {
  .users-table__row {
    grid-template-columns: minmax(0, 1fr);
  }
  .users-table__cell--actions {
    justify-content: flex-start;
  }
  .users-table__tokens-header, .users-table__tokens-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .users-table__tokens-cell--actions {
    justify-content: flex-start;
    margin-top: 4px;
  }
}

.users-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.users-modal__content {
  width: 100%;
  max-width: 420px;
  background: rgb(24, 26, 30);
  border-radius: 16px;
  padding: 20px 22px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.users-modal__title {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 4px;
}
.users-modal__row {
  width: 100%;
}
.users-modal__actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/UsersList/UsersList.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACJ;AAEE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAFF;AAIE;EAEE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;AAME;EACE,kCAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gDAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;AALJ;AAQE;EACE,eAAA;EACA,cAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,gDAAA;AANJ;AASE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;AASI;EACE,gBAAA;AAPN;AAUI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AARN;AAYE;EACE,aAAA;EACA,gBAAA;EACA,sEAAA;EACA,UAAA;EACA,eAAA;EACA,iCAAA;AAVJ;AAaE;EACE,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAXJ;AAcE;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AAZJ;AAeE;EACE,iBAAA;EACA,UAAA;EACA,oBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AAfJ;AAmBE;EACE,aAAA;EACA,QAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAlBJ;AAsBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AApBJ;AAqBI;EACE,cAAA;AAnBN;AAuBE;EACE,eAAA;AArBJ;AAwBE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,uCAAA;EACA,iCAAA;EACA,gBAAA;AAvBJ;AA0BE;EAEE,aAAA;EACA,0DAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kCAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;AA3BJ;AA8BE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA5BJ;AA8BI;EACE,gBAAA;AA5BN;AA+BI;EACE,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA7BN;AAgCI;EACE,aAAA;EACA,yBAAA;AA9BN;AAkCE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AAjCJ;AAoCE;EACE;IACE,aAAA;EAlCJ;EAqCE;IACE,aAAA;IACA,gDAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EAnCJ;EAsCE;IACE,mBAAA;EApCJ;EAuCE;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EArCJ;EAwCE;IAEE,0DAAA;IACA,iBAAA;EAvCJ;EA0CE;IACE,sBAAA;IACA,uBAAA;EAxCJ;AACF;AA2CE;EACE;IACE,qCAAA;EAzCJ;EA4CE;IACE,2BAAA;EA1CJ;EA6CE;IAEE,qCAAA;EA5CJ;EA+CE;IACE,2BAAA;IACA,eAAA;EA7CJ;AACF;;AAiDA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA9CF;AAgDE;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA9CJ;AAiDE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AA/CJ;AAkDE;EACE,WAAA;AAhDJ;AAmDE;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AAjDJ","sourcesContent":[".users {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n\r\n  &__header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n  }\r\n\r\n  &__title {\r\n    color: #ffffff;\r\n    margin-bottom: 12px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  &__pagination {\r\n    margin-top: 16px;\r\n  }\r\n}\r\n\r\n.users-table {\r\n  width: 100%;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n\r\n  &__header,\r\n  &__row {\r\n    display: grid;\r\n    column-gap: 8px;\r\n    padding: 15px 26px;\r\n    align-items: center;\r\n    border-radius: 20px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  &__header {\r\n    background: rgba(35, 38, 43, 0.95);\r\n    font-size: 12px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1.3px;\r\n    color: #a9adb3;\r\n    grid-template-columns: 0.6fr 2fr 2fr 1.4fr 1.2fr;\r\n  }\r\n\r\n  &__body {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  &__row {\r\n    font-size: 14px;\r\n    color: #f4f4f4;\r\n    border: 1px solid rgba(70, 74, 81, 0.7);\r\n    background: rgba(35, 38, 43, 0.95);\r\n    border-radius: 20px;\r\n    grid-template-columns: 0.6fr 2fr 2fr 1.4fr 1.2fr;\r\n  }\r\n\r\n  &__cell {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n\r\n    &--id {\r\n      font-weight: 500;\r\n    }\r\n\r\n    &--actions {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      justify-content: flex-end;\r\n    }\r\n  }\r\n\r\n  &__accordion {\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;\r\n    opacity: 0;\r\n    padding: 0 16px;\r\n    background: rgba(18, 19, 22, 0.9);\r\n  }\r\n\r\n  &__accordion-inner {\r\n    padding-top: 12px;\r\n    padding-bottom: 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n  }\r\n\r\n  &__accordion-rows{\r\n    display: flex;\r\n    align-items: flex-end;\r\n    gap: 25px;\r\n  }\r\n\r\n  &__accordion--open {\r\n    max-height: 600px;\r\n    opacity: 1;\r\n    padding: 0 16px 12px;\r\n  }\r\n\r\n  &__form {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 12px;\r\n    align-items: center;\r\n  }\r\n\r\n  &__form-row {\r\n    min-width: 220px;\r\n    max-width: 320px;\r\n    flex: 1 1 220px;\r\n\r\n  }\r\n\r\n  &__form-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n  }\r\n\r\n  &__roles {\r\n    display: flex;\r\n    gap: 12px;\r\n    align-items: center;\r\n\r\n  }\r\n\r\n  &__roles-row {\r\n    display: flex;\r\n    gap: 12px;\r\n    align-items: center;\r\n    >*{\r\n      flex-shrink: 0;\r\n    }\r\n  }\r\n\r\n  &__tokens {\r\n    margin-top: 8px;\r\n  }\r\n\r\n  &__tokens-title {\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  &__tokens-table {\r\n    border-radius: 12px;\r\n    border: 1px solid rgba(70, 74, 81, 0.7);\r\n    background: rgba(24, 26, 30, 0.9);\r\n    overflow: hidden;\r\n  }\r\n\r\n  &__tokens-header,\r\n  &__tokens-row {\r\n    display: grid;\r\n    grid-template-columns: 0.6fr 1.1fr 1.1fr 3.2fr 1.2fr 1.2fr;\r\n    column-gap: 8px;\r\n    padding: 10px 14px;\r\n    align-items: center;\r\n  }\r\n\r\n  &__tokens-header {\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1.2px;\r\n    color: #a9adb3;\r\n    background: rgba(35, 38, 43, 0.95);\r\n  }\r\n\r\n  &__tokens-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n    max-height: 300px;\r\n  }\r\n\r\n  &__tokens-cell {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    font-size: 13px;\r\n\r\n    &--id {\r\n      font-weight: 500;\r\n    }\r\n\r\n    &--token {\r\n      white-space: normal;\r\n      word-break: break-all;\r\n      font-size: 11px;\r\n      line-height: 1.3;\r\n      max-height: 3.6em;\r\n    }\r\n\r\n    &--actions {\r\n      display: flex;\r\n      justify-content: flex-end;\r\n    }\r\n  }\r\n\r\n  &__tokens-empty {\r\n    padding: 10px 14px;\r\n    font-size: 13px;\r\n    color: #a9adb3;\r\n  }\r\n\r\n  &__empty {\r\n    padding: 16px;\r\n    text-align: center;\r\n    color: #a9adb3;\r\n  }\r\n\r\n  @media (max-width: 1024px) {\r\n    &__header {\r\n      display: none;\r\n    }\r\n\r\n    &__row {\r\n      display: grid;\r\n      grid-template-columns: repeat(2, minmax(0, 1fr));\r\n      row-gap: 4px;\r\n      column-gap: 8px;\r\n      padding: 12px 16px;\r\n    }\r\n\r\n    &__cell {\r\n      white-space: normal;\r\n    }\r\n\r\n    &__cell--actions {\r\n      grid-column: 1 / -1;\r\n      justify-content: flex-start;\r\n      margin-top: 6px;\r\n    }\r\n\r\n    &__tokens-header,\r\n    &__tokens-row {\r\n      grid-template-columns: 0.6fr 2.2fr 1.2fr 1.4fr 1.4fr 1.2fr;\r\n      padding: 8px 10px;\r\n    }\r\n\r\n    &__roles-row {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 600px) {\r\n    &__row {\r\n      grid-template-columns: minmax(0, 1fr);\r\n    }\r\n\r\n    &__cell--actions {\r\n      justify-content: flex-start;\r\n    }\r\n\r\n    &__tokens-header,\r\n    &__tokens-row {\r\n      grid-template-columns: minmax(0, 1fr);\r\n    }\r\n\r\n    &__tokens-cell--actions {\r\n      justify-content: flex-start;\r\n      margin-top: 4px;\r\n    }\r\n  }\r\n}\r\n\r\n.users-modal {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  background: rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n\r\n  &__content {\r\n    width: 100%;\r\n    max-width: 420px;\r\n    background: rgba(24, 26, 30, 1);\r\n    border-radius: 16px;\r\n    padding: 20px 22px;\r\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n\r\n  &__title {\r\n    font-size: 18px;\r\n    color: #ffffff;\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  &__row {\r\n    width: 100%;\r\n  }\r\n\r\n  &__actions {\r\n    margin-top: 8px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 8px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
